import { useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useConsent } from '../context/ConsentContext';
import { trackingEnabled } from '../config/tracking';

// The signed-in identity is only pushed to the analytics layer when the
// student allowed the analytics cookies.
//
// Only a pseudonymous id goes out: the e-mail address and the phone
// number are personal data and never leave the app (the privacy policy
// promises anonymous visit statistics).
const GtagUserData = () => {
    const { user } = useUser();
    const { consent } = useConsent();

    useEffect(() => {
        if (!trackingEnabled || !consent.analytics) return;
        if (user && window.gtag) {
            window.gtag('set', 'user_data', {
                "user_id": user.id,
            });
        }
    }, [user, consent.analytics]);

    return null;
};

export default GtagUserData;
